import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicNetworkDnsDomainTransferListParamsRaw,
	LWApiPublicNetworkDnsDomainTransferListResultRaw,
} from '@liquidweb-dev/club-sauce/public/network/dns/domain/transfer/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const TRANSFER_LIST_QUERY_KEY = '/network/dns/domain/transfer/list';

const useTransferList = <
	TData = LWApiPublicNetworkDnsDomainTransferListResultRaw,
>(
	params?: LWApiPublicNetworkDnsDomainTransferListParamsRaw,
	options?: UseQueryOptions<
		LWApiPublicNetworkDnsDomainTransferListResultRaw,
		ApiErrorI,
		TData
	>,
) =>
	useQuery({
		queryKey: [TRANSFER_LIST_QUERY_KEY, params],
		queryFn: () => api.network.dns.domain.transfer.apiRaw.list(params),
		...options,
	});

export default useTransferList;
